var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('billingoverview',{key:_vm.billingSummary,attrs:{"billingHistory":_vm.billingSummary,"overallsummary":_vm.overallSummary,"allGlobalTotals":_vm.allGlobalTransactions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }